module.exports = __webpack_public_path__ + "assets/fe27285074f1ec87c72c63227aa049bb.mp3";